import { useLocale } from '@gov-nx/core/service';
import { useMojeSouborySeznamContext } from '@gov-nx/module/page';
import { Button, ButtonGroupLayout, Icon } from '@gov-nx/ui/web';

export const EmptyBinButton = () => {
	const { code, emptyRecycleBin } = useMojeSouborySeznamContext();
	const { t } = useLocale(code);

	return (
		<ButtonGroupLayout>
			<Button
				aria-label={t('akce.vysypat-kos')}
				color="error"
				type="solid"
				size="m"
				isExpandedMobile
				onClick={emptyRecycleBin.emptyBinModal.setTrue}
				iconStart={
					<Icon
						name="trash"
						type="templates"
					/>
				}>
				{t('akce.vysypat-kos')}
			</Button>
		</ButtonGroupLayout>
	);
};
